import { Routes, UrlSegment } from '@angular/router';
import { authGuard, createAuthCallbackRoute, createLoggedOutRoute } from '@presencelearning/auth';
import { AboutComponent } from './about/about.component';
import { HomeComponent } from './home/home.component';
import { ProviderDoorComponent } from './lessonspace/provider-door.component';
import { StudentDoorComponent } from './lessonspace/student-door.component';

const reservedRooms = new Set(['session', 'about', 'join', 'auth']);

export function isRoomRoute(_route: unknown, segments: UrlSegment[]): boolean {
  return segments.length === 1 && !reservedRooms.has(segments[0].path.toLowerCase());
}

export const routes: Routes = [
  createAuthCallbackRoute(),
  createLoggedOutRoute(),
  { path: '', component: HomeComponent, canActivate: [authGuard] },
  { path: 'session', component: ProviderDoorComponent, canActivate: [authGuard] },
  { path: 'about', component: AboutComponent, canActivate: [authGuard] },
  // Students have no Sirius account. The segment is the leader's space id.
  // Lessonspace's waiting room admits them.
  { path: ':roomId', component: StudentDoorComponent, canMatch: [isRoomRoute] },
];
